<template>
  <div>
    <div class="input_div">
      <el-select :value="type" value-key="key" :size="size" placeholder="日/月" @input="change($event)" :clearable="true">
        <el-option label="日" value="0" />
        <el-option label="月" value="1" />
      </el-select>
    </div>
    <div class="input_div">
      <el-date-picker
        v-if="type === '0'"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        v-model="date"
        type="date"
        placeholder="选择日"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-date-picker
        v-if="type === '1'"
        v-model="date"
        format="yyyy-MM"
        type="month"
        placeholder="选择月份"
        :picker-options="pickerOptions">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      date: '',
      type: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > new Date()
        }
      }
    }
  },
  props: ['value', 'size'],
  methods: {
    change: function (val) {
      this.type = val
      this.$emit('input', this.date)
    },
    result: function () {
      if (this.date && typeof this.date === 'object') {
        this.$emit('input', this.date.getFullYear().toString() + '-' + (this.date.getMonth() + 1).toString().padStart(2, '0'))
      } else {
        this.$emit('input', this.date)
      }
    }
  },
  mounted () {
  },
  watch: {
    type: function (val, oldVal) {
      const d = new Date()
      if (val === '') {
        this.date = null
      } else {
        if (this.type === '0') {
          this.date = d.getFullYear().toString() + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0')
        } else {
          this.date = d
        }
      }
      this.result()
    },
    date: function (val, oldVal) {
      this.date = val
      this.result()
    }
  }
}
</script>
<style>
  .input_div{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/card/components/MonthSelect.vue